import "./Announcement.css";
import { useRef, useEffect, useState } from "react";
import { CircleAlert, X } from "lucide-react";
import FallbackImg from "../FallbackImg";

const Announcement = ({ memo, current, total, onClose, onDontShow }) => {
  const modalRef = useRef(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(false);
  }, [memo]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleString("en-MY", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  if (!memo) return null;

  return (
    <div className="announcement">
      <div className="announcement-content" ref={modalRef}>
        <div className="announcement-title-container">
          <div className="announcement-title">
            <div className="announcement-icon">
              <CircleAlert />
            </div>
            <div>
              <strong>Announcement</strong>
              <div className="announcement-date">
                {formatDate(memo.updated_date)}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {total > 1 && (
              <span style={{ fontSize: 13, color: "#ffffff" }}>
                {current} / {total}
              </span>
            )}
            <button className="announce-close-button" onClick={onClose}>
              <X />
            </button>
          </div>
        </div>

        <div className="announcement-img">
          <FallbackImg src={memo.photo_url} alt={memo.header} />
        </div>
        <div className="announcement-main">
          <div className="announcement-maintitle">{memo.header}</div>
          <div className="announcement-maincontent">{memo.description}</div>
        </div>

        <div className="announcement-sub">
          <div className="announcement-subcontent">
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => {
                setChecked(e.target.checked);
                if (e.target.checked) {
                  onDontShow(memo);
                }
              }}
            />
            Don't show this again
          </div>

          <button className="announcement-button" onClick={onClose}>
            {current < total ? "Next" : "Close"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Announcement;
